import { render, staticRenderFns } from "./BeginTodayButton.vue?vue&type=template&id=2ec39c98&scoped=true&"
import script from "./BeginTodayButton.vue?vue&type=script&lang=js&"
export * from "./BeginTodayButton.vue?vue&type=script&lang=js&"
import style0 from "./BeginTodayButton.vue?vue&type=style&index=0&id=2ec39c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec39c98",
  null
  
)

export default component.exports